<div
  ngbDropdown
  class="mr-2 d-inline-block"
  #dropdown="ngbDropdown"
  (mouseenter)="dropdown.open()"
  (mouseleave)="dropdown.close()"
>
  <div class="btn-group">
    <button
      type="button"
      class="btn btn-secondary app-control-dropdown"
      (click)="$event.preventDefault(); dropdown.open()"
      ngbDropdownAnchor
    >
      <i class="cc-icon cc-icon-table"></i>
    </button>
  </div>
  <div ngbDropdownMenu class="dropdown-menu px-3" (click)="$event.stopPropagation(); dropdown.close()">
    <div
      class="option-dropdown-item form-check form-check-inline justify-content-start ml-0"
      ccSegmentCTA="Template Field Dropdown Options"
      ctaContext="Table"
      [ctaHierarchy]="hierarchy"
      *ngFor="let tableType of tableTypes; let i = index"
    >
      <input
        class="form-check-input"
        type="radio"
        [name]="model.id + 'tableType'"
        [value]="tableType.type"
        [attr.data-cy]="tableType.type"
        [(ngModel)]="model.kind"
        (change)="onChange(tableType.type)"
        [id]="'table-radio-' + i + '-' + identifier"
      />
      <label i18n [for]="'table-radio-' + i + '-' + identifier" class="default-label form-check-label">{{
        tableType.title
      }}</label>
    </div>
  </div>
</div>
